import React from "react";
import Button from "../Button";
import Agreements from "../../pages/Agreements";
import { ContentAgreementsModal, ContentAgreementsInfo, ContentButton } from "./styles";

interface AgreementsModalProps {
    onCloseModal?: () => void;
}

const AgreementsModal: React.FC<AgreementsModalProps> = ({ onCloseModal }: AgreementsModalProps) => {
    return (
        <ContentAgreementsModal>
            <ContentAgreementsInfo>
                <Agreements />
            </ContentAgreementsInfo>
            <ContentButton>
                {
                    onCloseModal &&
                        (
                            <Button
                                button={{ type: 'button' }}
                                atributes={{
                                    buttonType: 'primary',
                                    textColor: '#fff',
                                    borderColor: '#dddddd',
                                    textSize: '24px'
                                }}
                                onClick={onCloseModal}
                            >
                                VOLTAR
                            </Button>
                        )
               }
            </ContentButton>
        </ContentAgreementsModal>
    )
}

export default AgreementsModal;